import * as Actions from "auth/store/actions";

const initialState = {
  data: {},
  current: null,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_USER_DATA: {
      return {
        ...initialState,
        ...action.payload,
        current:
          process.env.NEXT_PUBLIC_APP_TYPE !== "teacher" &&
          action.payload.Children[0],
      };
    }
    case Actions.REMOVE_USER_DATA: {
      return {
        ...initialState,
      };
    }
    case Actions.USER_LOGGED_OUT:
      return initialState;
    default: {
      return state;
    }
  }
};

export default user;
